import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import UserForm from './components/user-form';
import Dialog from '@/components/common/dialog';
import { getList as _getList, deleteTenantUser as _deleteTenantUser, authorize as _authorize, forbidden as _forbidden, addTenantUser as _addTenantUser, editTenantUser } from '@/api/setting/user';
export default {
  name: 'setting-user',
  computed: {
    isAuth: function isAuth() {
      return this.$auth();
    },
    summaryData: function summaryData() {
      var data = this.currentTableData;
      var isValid = this.getSummaries(data, 'isValid');
      var State = this.getSummaries(data, 'State');
      return [{
        label: '绑定租户',
        value: isValid
      }, {
        label: '允许使用',
        value: State
      }];
    },
    currentList: function currentList() {
      return this.filterList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    dataList: function dataList() {
      var _this = this;
      if (this.type.type === '') {
        return this.currentTableData;
      }
      return this.currentTableData.filter(function (item) {
        return item[_this.type.key] === _this.type.value;
      });
    },
    filterList: function filterList() {
      var _this2 = this;
      var key = this.searchKey;
      var data = this.dataList;
      if (key !== undefined) {
        return data.filter(function (item) {
          return _this2.filterKeyWords(item, key);
        });
      }
      return data;
    },
    filterName: function filterName() {
      var _this3 = this;
      var list = this.types;
      var item = list.find(function (type) {
        return type.type === _this3.type.type;
      });
      return item.label;
    }
  },
  data: function data() {
    return {
      currentPage: 1,
      pageSize: 10,
      activeName: 'all',
      currentTableData: [],
      template: null,
      userType: {
        0: '系统',
        1: '租户',
        2: '注册',
        3: '批量'
      },
      sysState: {
        '-1': '未绑定',
        0: '禁止',
        1: '正常'
      },
      loading: false,
      selectedArr: [],
      types: [{
        label: '全部',
        type: ''
      }, {
        label: '绑定租户',
        key: 'isValid',
        type: 0,
        value: true
      }, {
        label: '解绑租户',
        key: 'isValid',
        type: 1,
        value: false
      }, {
        label: '允许使用',
        key: 'State',
        type: 2,
        value: true
      }, {
        label: '禁止使用',
        key: 'State',
        type: 3,
        value: false
      }],
      searchKey: '',
      type: {
        type: ''
      }
    };
  },
  methods: {
    handleSizeChange: function handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
    },
    filterKeyWords: function filterKeyWords(item, key) {
      if (key === undefined || key === '') {
        return true;
      }
      return item.nickName && item.nickName.indexOf(key) !== -1 || item.tenantName && item.tenantName.indexOf(key) !== -1 || item.tenantNickName && item.tenantNickName.indexOf(key) !== -1 || item.tenantUserName && item.tenantUserName.indexOf(key) !== -1 || item.userName && item.userName.indexOf(key) !== -1;
    },
    createUser: function createUser(item) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this4.$awaitTo(_this4.$dialog(UserForm, {
                dialog: {
                  title: item ? '编辑' : '新增',
                  width: '360px'
                },
                props: {
                  data: item,
                  list: _this4.currentTableData,
                  handler: item ? editTenantUser : _this4.addTenantUser
                }
              }, function (template) {
                _this4.template = template;
              }));
            case 1:
              _yield$_this4$$awaitT = _context.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 2);
              err = _yield$_this4$$awaitT2[0];
              data = _yield$_this4$$awaitT2[1];
              _this4.template = null;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (item) {
                _this4.getList();
              }
              // this.addTenantUser([data], false)
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getSummaries: function getSummaries(data, key) {
      return data.reduce(function (prev, cur) {
        return +cur[key] + prev;
      }, 0);
    },
    updateStatus: function updateStatus(item, key) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var text, _yield$_this5$$awaitT, _yield$_this5$$awaitT2, err, handler;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              text = {
                'isValid': item[key] ? '确定绑定该租户?' : '确定解除绑定该租户?',
                'State': item[key] ? '确定授权该租户?' : '确定禁止该租户?'
              };
              _context2.n = 1;
              return _this5.$awaitTo(_this5.$$confirm("".concat(text[key])));
            case 1:
              _yield$_this5$$awaitT = _context2.v;
              _yield$_this5$$awaitT2 = _slicedToArray(_yield$_this5$$awaitT, 1);
              err = _yield$_this5$$awaitT2[0];
              if (!err) {
                _context2.n = 2;
                break;
              }
              item[key] = !item[key];
              return _context2.a(2);
            case 2:
              handler = {
                'isValid': item[key] ? _this5.addTenantUser : _this5.deleteTenantUser,
                'State': item[key] ? _this5.authorize : _this5.forbidden
              };
              handler[key]([item]);
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    handleCommand: function handleCommand(type) {
      this.type = type;
    },
    forbidden: function forbidden(items) {
      var _arguments = arguments,
        _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var flag, data, _yield$_this6$$awaitT, _yield$_this6$$awaitT2, err, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              flag = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : true;
              data = _this6.selectedArr;
              if (!items) {
                _context3.n = 1;
                break;
              }
              data = items;
              _context3.n = 2;
              break;
            case 1:
              _t = flag;
              if (!_t) {
                _context3.n = 2;
                break;
              }
              _context3.n = 2;
              return _this6.$$confirm('确定禁用所选用户?');
            case 2:
              data = data.map(function (item) {
                return item.userId;
              });
              _context3.n = 3;
              return _this6.$awaitTo(_forbidden({
                uidsJson: JSON.stringify(data)
              }));
            case 3:
              _yield$_this6$$awaitT = _context3.v;
              _yield$_this6$$awaitT2 = _slicedToArray(_yield$_this6$$awaitT, 1);
              err = _yield$_this6$$awaitT2[0];
              if (!err) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2);
            case 4:
              _this6.$message.success('操作成功');
              _this6.getList();
            case 5:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    authorize: function authorize(items) {
      var _arguments2 = arguments,
        _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var flag, data, _yield$_this7$$awaitT, _yield$_this7$$awaitT2, err, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              flag = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : true;
              data = _this7.selectedArr;
              if (!items) {
                _context4.n = 1;
                break;
              }
              data = items;
              _context4.n = 2;
              break;
            case 1:
              _t2 = flag;
              if (!_t2) {
                _context4.n = 2;
                break;
              }
              _context4.n = 2;
              return _this7.$$confirm('确定授权所选用户?');
            case 2:
              data = data.map(function (item) {
                return {
                  nickname: item.tenantNickName,
                  phone: item.userName
                };
              });
              _context4.n = 3;
              return _this7.$awaitTo(_authorize({
                RegListJson: JSON.stringify(data)
              }));
            case 3:
              _yield$_this7$$awaitT = _context4.v;
              _yield$_this7$$awaitT2 = _slicedToArray(_yield$_this7$$awaitT, 1);
              err = _yield$_this7$$awaitT2[0];
              if (!err) {
                _context4.n = 4;
                break;
              }
              return _context4.a(2);
            case 4:
              _this7.$message.success('操作成功');
              _this7.getList();
            case 5:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    addTenantUser: function addTenantUser(items) {
      var _arguments3 = arguments,
        _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var flag;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              flag = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : true;
              return _context6.a(2, new Promise(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(resolve, reject) {
                  var data, _yield$_this8$$awaitT, _yield$_this8$$awaitT2, err, _t3;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.n) {
                      case 0:
                        data = _this8.selectedArr;
                        if (!items) {
                          _context5.n = 1;
                          break;
                        }
                        data = items;
                        _context5.n = 2;
                        break;
                      case 1:
                        _t3 = flag;
                        if (!_t3) {
                          _context5.n = 2;
                          break;
                        }
                        _context5.n = 2;
                        return _this8.$$confirm('确定绑定所选用户?');
                      case 2:
                        data = data.map(function (item) {
                          return {
                            email: item.email,
                            phone: item.userName,
                            nickName: item.tenantNickName,
                            username: item.tenantUserName
                          };
                        });
                        _context5.n = 3;
                        return _this8.$awaitTo(_addTenantUser({
                          jsonreglist: JSON.stringify(data)
                        }));
                      case 3:
                        _yield$_this8$$awaitT = _context5.v;
                        _yield$_this8$$awaitT2 = _slicedToArray(_yield$_this8$$awaitT, 1);
                        err = _yield$_this8$$awaitT2[0];
                        if (!err) {
                          _context5.n = 4;
                          break;
                        }
                        reject(err);
                        return _context5.a(2);
                      case 4:
                        _this8.$message.success('操作成功');
                        _this8.getList();
                        resolve();
                      case 5:
                        return _context5.a(2);
                    }
                  }, _callee5);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }()));
          }
        }, _callee6);
      }))();
    },
    deleteTenantUser: function deleteTenantUser(items) {
      var _arguments4 = arguments,
        _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var flag, data, _yield$_this9$$awaitT, _yield$_this9$$awaitT2, err, _t4;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              flag = _arguments4.length > 1 && _arguments4[1] !== undefined ? _arguments4[1] : true;
              data = _this9.selectedArr;
              if (!items) {
                _context7.n = 1;
                break;
              }
              data = items;
              _context7.n = 2;
              break;
            case 1:
              _t4 = flag;
              if (!_t4) {
                _context7.n = 2;
                break;
              }
              _context7.n = 2;
              return _this9.$$confirm('确定解绑?');
            case 2:
              data = data.map(function (item) {
                return item.userId;
              });
              _context7.n = 3;
              return _this9.$awaitTo(_deleteTenantUser({
                uidsJson: JSON.stringify(data)
              }));
            case 3:
              _yield$_this9$$awaitT = _context7.v;
              _yield$_this9$$awaitT2 = _slicedToArray(_yield$_this9$$awaitT, 1);
              err = _yield$_this9$$awaitT2[0];
              if (!err) {
                _context7.n = 4;
                break;
              }
              return _context7.a(2);
            case 4:
              _this9.forbidden(items, false);
            case 5:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectedArr = val;
    },
    getList: function getList() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _yield$_getList, data;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _getList();
            case 1:
              _yield$_getList = _context8.v;
              data = _yield$_getList.data;
              _this0.currentTableData = data.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  isValid: item.isValid === 'true',
                  State: item.state === 1
                });
              });
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    }
  },
  created: function created() {
    this.getList();
  }
};